const HOST = process.env.REACT_APP_OMS_BACKEND  || '';
// https://oms-staging.foodcourt.am
// staging url

export const BASE_URL = HOST+'/api/';
export const BASE_SOCKET_SERVER = HOST +  '/';
export const LANG = 'hy';
export const FORCE_ORDER_RECEIVER_LOCATION = false;
